import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

import { APP_DOCUMENT_TITLE_SUFFIX } from './app-document-title';

/**
 * Define `document.title` como `{title da rota} | {APP_DOCUMENT_TITLE_SUFFIX}`.
 * O texto da rota vem da propriedade `title` em {@link Routes} (rota ativa mais específica).
 */
@Injectable()
export class MwTitleStrategy extends TitleStrategy {
  private readonly docTitle = inject(Title);

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const pageTitle = this.buildTitle(snapshot);
    const suffix = APP_DOCUMENT_TITLE_SUFFIX;
    if (pageTitle) {
      this.docTitle.setTitle(`${pageTitle} | ${suffix}`);
      return;
    }
    this.docTitle.setTitle(suffix);
  }
}
